import { useState, useContext } from "react";
import { Form, Button } from "react-bootstrap";
import { SiteManContext } from "../SiteManContext";

const AddSiteForm = ({ handleClose }) => {
  const { addSite } = useContext(SiteManContext);

  const [formData, setFormData] = useState({
    idpresenze: "",
    nome: "",
    tipologia: "",
    comune: "",
    localita: "",
    stato_conservazione: "",
    compilatore: "",
    data: new Date().toISOString().split("T")[0],
    visibilita: "",
    descrizione: "", // <-- Nuovo campo
    note: "",        // <-- Nuovo campo
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addSite(formData);
    handleClose();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-2">
        <Form.Label>ID Presenze</Form.Label>
        <Form.Control type="text" name="idpresenze" value={formData.idpresenze} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Nome</Form.Label>
        <Form.Control type="text" name="nome" value={formData.nome} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Tipologia</Form.Label>
        <Form.Control type="text" name="tipologia" value={formData.tipologia} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Comune</Form.Label>
        <Form.Control type="text" name="comune" value={formData.comune} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Localit�</Form.Label>
        <Form.Control type="text" name="localita" value={formData.localita} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Stato Conservazione</Form.Label>
        <Form.Control type="text" name="stato_conservazione" value={formData.stato_conservazione} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Compilatore</Form.Label>
        <Form.Control type="text" name="compilatore" value={formData.compilatore} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Data</Form.Label>
        <Form.Control type="date" name="data" value={formData.data} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Visibilit�</Form.Label>
        <Form.Control type="text" name="visibilita" value={formData.visibilita} onChange={handleChange} />
      </Form.Group>

      {/* Nuovi campi di testo estesi */}
      <Form.Group className="mb-2">
        <Form.Label>Descrizione</Form.Label>
        <Form.Control as="textarea" rows={3} name="descrizione" value={formData.descrizione} onChange={handleChange} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label>Note</Form.Label>
        <Form.Control as="textarea" rows={2} name="note" value={formData.note} onChange={handleChange} />
      </Form.Group>

      <Button variant="success" type="submit" className="mt-3 w-100">
        Aggiungi Sito
      </Button>
    </Form>
  );
};

export default AddSiteForm;